import React, { useEffect, useState } from "react";
import "./MainBody.css";
// import TextField from "@mui/material/TextField";
// import { FcLock } from "react-icons/fc";
// import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { Universal } from "./BackendURL";
import jsonData from "../../data.json"
//import Data from "../Data";


const DataScreen = (props) => {
  const [data, setData] = useState([])
  useEffect(() => {

     const fetchData = async () =>{
      try {
        console.log(jsonData)
        let res = jsonData.data
        // const resData = await res.json()
        setData(res)
      } catch (error) {
        toast.error("Something Went Wrong! Check Internet Connection and Try Again")
        console.log(error)
      }
     }
     fetchData()
  }, []);

  return (
    <div className="data-screen-container">


    {data.map((element, index)=>{
      return(
        <Accordion key={index} sx={{margin:'10px', backgroundColor:`${element.color}`, borderRadius:'15px', boxShadow:'0', border:'0'}}>
        <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>{element.header}</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <TableContainer component={Paper}>
      <Table sx={{ minWidth: 250 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell align="right">Phone Number</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>

          {element.data.map((row, index) => (
            <TableRow
              key={index}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.Name}
              </TableCell>
              <TableCell align="right">
                <a href={`tel:${row.Mobile}`}>{row.Mobile}</a>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
        </AccordionDetails>
      </Accordion>
      )
})}
    
      </div>
  );
};

export default DataScreen;
